import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useSuggestedCareersQuery = (companyName, options = {}) => {
  return useQuery({
    queryKey: QUERY_KEYS.suggestedCareersByCompany(companyName),
    queryFn: () => {
      return query({
        query: 'bedrockAgent',
        variables: { company_name: companyName }
      })
    },
    enabled: !!companyName,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...options
  })
}
